import { render } from "./OverviewDepartureSideNav.vue?vue&type=template&id=7076f9c0"
import script from "./OverviewDepartureSideNav.vue?vue&type=script&lang=js"
export * from "./OverviewDepartureSideNav.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__